var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25977 7.89977L7.89977 2.25977L93.7398 88.0998L88.0998 93.7398L76.7398 82.3798C75.2998 84.4198 72.9398 85.7398 70.2598 85.7398C65.8598 85.7398 62.2998 82.1398 62.2998 77.7398C62.2998 75.0598 63.6198 72.6998 65.6198 71.2598L60.0998 65.7398H30.2598C25.8598 65.7398 22.2598 62.1398 22.2598 57.7398C22.2598 56.3398 22.6198 55.0198 23.2598 53.8998L28.6598 44.0998L19.8198 25.4598L2.25977 7.89977ZM34.6598 49.7398L30.2598 57.7398H52.0998L44.0998 49.7398H34.6598ZM82.2598 13.7398H30.7398L38.7398 21.7398H75.4998L64.4598 41.7398H58.6998L66.4598 49.4998C68.6198 48.9398 70.4198 47.5398 71.4598 45.6198L85.7798 19.6598C87.2598 17.0198 85.2998 13.7398 82.2598 13.7398ZM22.2998 77.7398C22.2998 73.3398 25.8598 69.7398 30.2598 69.7398C34.6598 69.7398 38.2598 73.3398 38.2598 77.7398C38.2598 82.1398 34.6598 85.7398 30.2598 85.7398C25.8598 85.7398 22.2998 82.1398 22.2998 77.7398Z",
    fill: "#C1C2C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveShoppingCart);
export default __webpack_public_path__ + "static/media/removeShoppingCart.b1258d85.svg";
export { ForwardRef as ReactComponent };